module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Required is the asterisk symbol use for mandatory inputs.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Require&gt;label text&lt;/Required&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Required/README.md
// module id = 381
// module chunks = 0